import { useRouter } from 'next/router'
import Script from 'next/script'
import { useFullPageLoadFor } from '../hooks/useFullPageLoadFor'

const GTM_ID = 'GTM-PLCLBKVH'

// Pages that collect or display member PHI. Tags can be published to a GTM
// container without a code review, so GTM must never run on these routes.
const PHI_ROUTES = [
  '/claims-verification',
  '/eligibility-verification',
  '/prior-auth-status',
  '/prior-auth-tool',
  '/prior-authorization',
  // Not covered by '/prior-authorization' above: matching is exact or by
  // '/prior-authorization/' prefix.
  '/prior-authorization-request',
]

const isPhiRoute = (path) => {
  const pathname = path.split(/[?#]/)[0].replace(/\/+$/, '') || '/'
  return PHI_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  )
}

const isGtmLoaded = () =>
  typeof window !== 'undefined' &&
  Boolean(document.getElementById('gtm-init'))

// If GTM was loaded on an earlier page, a client-side route change to a PHI
// page becomes a full page load.
const needsFullLoad = (url) => isGtmLoaded() && isPhiRoute(url)

const GoogleTagManager = () => {
  const router = useRouter()
  const blocked = isPhiRoute(router.asPath)

  useFullPageLoadFor(needsFullLoad)

  if (blocked) return null

  return (
    <>
      <Script
        id="gtm-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`,
        }}
      />
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}

export default GoogleTagManager
